<template>
  <b-container class="bv-example-row" fluid>
      <b-link class="link-text" v-b-modal.rules>Rappel des règles</b-link>
      <b-modal id="rules" title="Rappel des règles du Fast food">
        <b-card class="custom-card" id="rights" header="<b>Autorisation à</b>">
          <b-list-group>
            <b-list-group-item>1 seul fast food par semaine</b-list-group-item>
            <b-list-group-item>2 non-fast-food par semaine</b-list-group-item>
          </b-list-group>
        </b-card>
        <b-card class="custom-card" id="allow" header="<b>Liste des non-fast-food</b>">
          <b-list-group>
            <b-list-group-item>Monoprix</b-list-group-item>
            <b-list-group-item>Salade</b-list-group-item>
            <b-list-group-item>Sandwich classique type boulangerie</b-list-group-item>
            <b-list-group-item>Bagel</b-list-group-item>
          </b-list-group>
        </b-card>
        <b-card class="custom-card" id="break" header="<b>En cas de non respect des règles*</b>">
          <b-list-group>
            <b-list-group-item>Laver le frigo</b-list-group-item>
            <b-list-group-item>Laver les micro ondes</b-list-group-item>
            <b-list-group-item>Faire un gâteau</b-list-group-item>
            <b-list-group-item>Tournée de cafés au BDC</b-list-group-item>
          </b-list-group>
          <p class="card-text mt-2" id="nb">
            * Cette liste n'est pas exhaustive. Les punitions sont variables et peuvent être soumises a des modifications unilatérales de la part de Coralie. Alors soyez sages ;)
          </p>
        </b-card>
        <b-card class="custom-card" id="except" header="<b>Exceptions</b>">
          <b-list-group>
            <b-list-group-item>Echange d'un bon fast food auprés de Coralie</b-list-group-item>
            <b-list-group-item>Je m'appelle Julien Adam</b-list-group-item>
          </b-list-group>
        </b-card>
        <b-card class="custom-card" id="howto" header="<b>Comment obtenir un bond fast food</b>">
          <b-list-group>
            <b-list-group-item>C'est mon anniversaire</b-list-group-item>
            <b-list-group-item>J'ai fait preuve d'héroïsme</b-list-group-item>
          </b-list-group>
        </b-card>
      </b-modal>
    </b-container>
</template>
<script>
export default {
  name: 'Rules'
};
</script>
<style lang="scss">
.bv-example-row {
  background-color: #31a4fd;
}
.link-text {
  color: #ffffff;
}
</style>
